import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsYogaNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M21.58 30H7.25a7.886 7.886 0 01-2.989-.584c-1.723-.707-3.106-2.014-3.796-3.677a6.04 6.04 0 01.217-5.113L8.673 3.812l.02-.04c.831-1.6 2.319-2.8 4.094-3.381a7.943 7.943 0 015.452.193c1.723.707 3.106 2.014 3.796 3.677a6.04 6.04 0 01-.217 5.113L21.044 11h8.077c1.907 0 3.157 1.995 2.325 3.71l-6.343 13.082A3.917 3.917 0 0121.58 30zM17.29 2.897a5.443 5.443 0 00-3.725-.13c-1.204.394-2.14 1.18-2.644 2.14L5.01 17.344a8.426 8.426 0 015.185.248c1.513.579 2.785 1.6 3.549 2.926l5.825-12.238.02-.039c.498-.96.544-2.04.136-3.024-.41-.991-1.269-1.842-2.435-2.32zm-5.298 20.184a3.024 3.024 0 00-.256-1.002c-.398-.897-1.246-1.696-2.434-2.151a5.925 5.925 0 00-3.798-.124c-1.206.368-2.121 1.124-2.625 2.017a3.538 3.538 0 00-.104 2.96c.41.992 1.269 1.843 2.435 2.322a5.388 5.388 0 002.04.397h14.33c.542 0 1.037-.31 1.274-.799l6.343-13.081a.075.075 0 00.01-.04.09.09 0 00-.015-.04.09.09 0 00-.03-.031.076.076 0 00-.04-.009h-9.268l-4.482 9.416a5.41 5.41 0 01-9.723.094l-.184-.368 2.236-1.118.184.368a2.91 2.91 0 004.107 1.189z"
        fill=""
      />
    </svg>
  )
);
SvgSportsYogaNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsYogaNormalMedium;
